import * as Types from '../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProgramFlowFragmentFragmentDoc } from '../../school/[providerSlug]/_components/generated';
import { QuestionnaireFlowFragmentFragmentDoc } from '../../dash/coach/questionnaire/generated';
import { SignInFlowFragmentFragmentDoc } from '../../login/generated';
export type FlowStateUpdateFragmentFragment = { __typename?: 'Customer', id: string, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null };

export type SkipperFlowFragmentFragment = { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> };

export const SkipperFlowFragmentFragmentDoc = gql`
    fragment SkipperFlowFragment on SkipperFlowState {
  id
  initialStep {
    id
    name
    status
  }
  steps {
    id
    name
    status
    isBlocking
  }
  hasBlockingStep
}
    ` as unknown as DocumentNode<SkipperFlowFragmentFragment, unknown>;
export const FlowStateUpdateFragmentFragmentDoc = gql`
    fragment FlowStateUpdateFragment on Customer {
  id
  programFlow(programId: $programId) @include(if: $programFlow) {
    ...ProgramFlowFragment
  }
  questionnaireFlow @include(if: $questionnaireFlow) {
    ...QuestionnaireFlowFragment
  }
  skipperFlow(flowIntent: $flowIntent) @include(if: $skipperFlow) {
    ...SkipperFlowFragment
  }
  signInFlow @include(if: $signInFlow) {
    ...SignInFlowFragment
  }
}
    ${ProgramFlowFragmentFragmentDoc}
${QuestionnaireFlowFragmentFragmentDoc}
${SkipperFlowFragmentFragmentDoc}
${SignInFlowFragmentFragmentDoc}` as unknown as DocumentNode<FlowStateUpdateFragmentFragment, unknown>;